import React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import DropDown from '../../../src/components/DropDown';
import MultiDropDown from '../../../src/components/MultiDropDown';
import CustomToast from '../../../src/components/Toast';
import { useData } from '../assignments/DataContext';
import { useActivityContext } from './context';
import '../../../src/styles/globalStyle.scss';
import { useGetActivityFiltersMutation } from '../../features/authentication/persistApiSlice';

const ActivitiesSearchFilter = () => {
  const defaultActivityFilters = {
    activityStatus: [],
    courseId: -1,
    folderId: -1,
    selectedKeyWord: '',
    searchText: '',
    sortColumn: 'ActivityName',
    sortDirection: 'ASC',
    isCollapsed: false,
    takeSize: 30
  };

  const [allCourses, setAllCourses] = useState([]);
  const [allFolders, setAllFolders] = useState([]);
  const [assignmentStatus, setAssignmentStatus] = useState([]);
  const [isStatusSelected , setIsStatusSelected ] = useState(false);
  const [dropdownKey, ] = React.useState(new Date().getTime().toString());
  const { courseData, folderData, assignmentStatusData, setReloadFolders, isDataLoaded} = useData();
  const [getFilters] = useGetActivityFiltersMutation();

  const {
    selectedCourseId,
    setSelectedCourseId,
    selectedFolderId,
    setSelectedFolderId,
    selectedStatusId,
    setSelectedStatusId,
    setSelectedKeyWord,
    selectedKeyWord,
    folderUpdateStatus,
    setFolderUpdateStatus,
    setSearch,
    filters,
    setFilters,
    setIsFiltersCollapsed,
    setFiltersInitialized,
    setSortColumn,
    setSortDirection
  } = useActivityContext();

  const getAllCoursesAsync = async () => {
    try {
      const obj = {
        id: -1,
        name: 'All Courses'
      };
      const courseArray = [obj, ...courseData];
      courseArray !== null && courseArray !== undefined
        ? setAllCourses(courseArray)
        : setAllCourses([obj]);
    } catch (error) {
      console.log(error);
    }
  };

  const replaceSpaceBeforeSecondUppercase = (text) => {
    return text.replace(/([a-z])([A-Z])/g, (match, lowercase, uppercase) => {
      return lowercase + ' ' + uppercase;
    });
  };

  const getActivityStatusAsync = async () => {
    try {
      const allAssignmentStatusArray = assignmentStatusData.map((item) => ({
        ...item,
        name: replaceSpaceBeforeSecondUppercase(item.name)
      }));
      setAssignmentStatus(allAssignmentStatusArray);
    } catch (error) {
      console.log(error);
    }
  };

  const setPersistData = () => {
    if (filters) {
      if (filters.courseId) setSelectedCourseId(filters.courseId);
      if (filters.folderId) setSelectedFolderId(filters.folderId);

      if (assignmentStatusData?.length > 0) {
        const updatedAssignmentStatus = assignmentStatusData.map((item) => ({
          ...item,
          isChecked: filters.activityStatus?.length == 0 ? true : (filters.activityStatus.includes(item.id) ? true : item.isChecked)
        }));
        setAssignmentStatus(updatedAssignmentStatus);
        const assignmentStatusIds = updatedAssignmentStatus
          .filter((item) => item?.isChecked === true)
          .map((itemId) => itemId.id);
        setSelectedStatusId(assignmentStatusIds);
      }
      setIsFiltersCollapsed(filters.isCollapsed);
      setSortColumn(filters.sortColumn);
      setSortDirection(filters.sortDirection);
      setFiltersInitialized(true);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if(isDataLoaded)
      {
        await Promise.all([getAllCoursesAsync(), getActivityStatusAsync()]);
        await getFiltersAsync();      
      }
    };
    fetchData();
  }, [isDataLoaded]);

  useEffect(() => {
    const folderArray = [];
    folderData.forEach((item) => {
      folderArray.push({
        id: item.folderID,
        name: item.description
      });
    });

    const objData = {
      id: -1,
      name: 'Any Folder'
    };

    const folderArrayResponse = [objData, ...folderArray];
    const updatedArray = folderArrayResponse.map((item) => ({
      ...item,
      name: item.name.replace(/Shared Assignments?/i, 'Shared Flashcards')
    }));

    setAllFolders(updatedArray);
  }, [folderData]);
  

  useEffect(() => {
    if (folderUpdateStatus) {
      setReloadFolders(true);
      setFolderUpdateStatus(false);
    }
  }, [folderUpdateStatus, setFolderUpdateStatus]);

  useEffect(() => {
    setSelectedStatusId([]);
  }, []);

  useEffect(() => {    
    if(filters)
      setPersistData();
  }, [filters]);
  
  const handleSelectCourse = (event) => {
    const selectedCourseId = parseInt(event.target.value);
    setSelectedCourseId(selectedCourseId);
  };

  const handleSelectFolder = (event) => {
    const selectedFolderId = parseInt(event.target.value);
    setSelectedFolderId(selectedFolderId);
  };

  const handleSelectKeyword = (event) => {
    const selectedKeyWord = event.target.value;
    setSelectedKeyWord(selectedKeyWord);
  };

  const searchHandler = () => {
    setIsStatusSelected(selectedStatusId.length == 0);
    if(selectedStatusId.length == 0)
      CustomToast('Select any Flashcard Status','warning');
    else {
      setFilters((prev) => ({
        ...(prev || {}),
        courseId: selectedCourseId !== '' ? selectedCourseId : -1,
        folderId: selectedFolderId !== '' ? selectedFolderId : -1,
        activityStatus: selectedStatusId,
        selectedKeyWord: selectedKeyWord || ''
      }));
      setSearch(new Date().getTime());
    }
  };

  const handleChangeActivityStatus = (e, assignmentStatus) => {
    const { key } = e;
    const selected = key !== '000' ? assignmentStatus.find((v) => v.id == key) : assignmentStatus;
    if (key === '000') {
      const tempValue = assignmentStatus.map((item) => ({
        ...item,
        isChecked: !assignmentStatus.filter((item) => item?.isChecked !== true).length < 1
      }));
      setAssignmentStatus(tempValue);
      const ids = tempValue.filter((item) => item?.isChecked === true).map((itemId) => itemId.id);
      if (ids.length === 0) setSelectedStatusId('');
      else setSelectedStatusId(ids);
    } else {
      const tempValue = assignmentStatus.map((item) =>
        item.id == key ? { ...item, isChecked: !selected.isChecked } : item
      );
      setAssignmentStatus(tempValue);
      const ids = tempValue.filter((item) => item?.isChecked === true).map((itemId) => itemId.id);
      if (ids.length === 0) setSelectedStatusId('');
      else setSelectedStatusId(ids);
    }
  };

  const getFiltersAsync = async () => {
    try {
      const persistFilters = await getFilters().unwrap();
      setFilters(persistFilters ?? defaultActivityFilters);
    } catch (error) {
      console.log(error);
      setFilters(defaultActivityFilters);
    }
  };

  return (
    <>
      <div>
        <div className="row align-items-center mb-4">
          <div className="col-lg-5">
            <h4 className="secondary-title mb-lg-0">Search Flashcards</h4>
          </div>
        </div>
        <Row>
          <Col className="mb-3">
            <DropDown
              key={dropdownKey}
              label="Select Course"
              value={allCourses}
              onChangeHandler={(e) => handleSelectCourse(e)}
              selectedValue={selectedCourseId}
              labelClassName="fs-14"
            />
          </Col>

          <Col className="mb-3">
            <DropDown
              key={dropdownKey}
              label="Select Folder"
              value={allFolders}
              onChangeHandler={(e) => handleSelectFolder(e)}
              selectedValue={selectedFolderId}
              labelClassName="fs-14"
            />
          </Col>
          <Col className="col-4 mb-3">
            <label className="form-label fs-14">Flashcard Status</label>
            <MultiDropDown
              key={dropdownKey}
              value={assignmentStatus}
              setValue={setAssignmentStatus}
              dropdownId="flashcardStatus"
              placeholder="Select Flashcard Status"
              handleChange={(e) => handleChangeActivityStatus(e, assignmentStatus)}
              selectedId={selectedStatusId}
              setSelectedId={setSelectedStatusId}
              description={true}
              selectAllText="All"
              showValidation ={isStatusSelected}
              selectedValClassName="fs-14"
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <label className="form-label fs-14">Keyword</label>
            <div className="d-flex flex-column flex-sm-row gap-4">
              <input
                type="text"
                className="form-control"
                placeholder=" "
                onChange={(e) => handleSelectKeyword(e)}
              />
              <button className="btn outline-btn btn-width fs-14" onClick={searchHandler}>
              Search
              </button>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default ActivitiesSearchFilter;
